import React from "react";
import { Link } from "react-router";
import Header from "../components/Header/Header";

const AppLayout = ({ children }) => {
  return (
    <>
      <Header />
      <main className="">{children}</main>
    </>
  );
};

export default AppLayout;
